import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, LinkIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { site } from '../data/site';
import { formations } from '../data/formations';
export function Footer() {
  return <footer className="border-t border-surface-line bg-brand-900 text-brand-100" data-id="element-33" data-mp="32lrkj907gphv">
      <div className="mx-auto grid max-w-content gap-10 px-5 py-14 lg:grid-cols-[1.3fr_1.2fr_0.9fr_1fr] lg:px-8" data-id="element-34" data-mp="36pz9n7aks7gm">
        <div data-id="element-35" data-mp="3ucxpc2qvfbdh">
          <div className="inline-flex rounded-lg bg-white px-3 py-2" data-id="element-36" data-mp="3ud7ifz77pyne">
            <img src={site.logo} alt={site.nom} className="h-7 w-auto" data-id="element-37" data-mp="387fpncvpdfs" />
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-brand-200" data-id="element-38" data-mp="3ldkgncakmqtt">
            Organisme de formation professionnelle certifié Qualiopi à {site.ville}. Formations
            digital, commerce, management et entrepreneuriat pour les entreprises, indépendants,
            salariés et associations de l’{site.departement}.
          </p>
          <div className="mt-5 flex items-center gap-3" data-id="element-39" data-mp="3l9k7bh9idvfe">
            <a href={site.instagram} target="_blank" rel="noreferrer" className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-white/20 text-white transition-colors duration-150 ease-out hover:bg-white/10" aria-label="Instagram Zillenium Academy" data-id="element-40" data-mp="3la288r748xtn">
              <InstagramIcon size={17} data-id="element-41" data-mp="82icbryzq8eb" />
            </a>
            <a href={site.linktree} target="_blank" rel="noreferrer" className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-white/20 text-white transition-colors duration-150 ease-out hover:bg-white/10" aria-label="Tous nos liens et documents" data-id="element-42" data-mp="80xk4905f1jm">
              <LinkIcon size={17} data-id="element-43" data-mp="qujmhqh7tl31" />
            </a>
          </div>
        </div>

        <nav aria-label="Nos formations" data-id="element-44" data-mp="msg7wsz920dj">
          <h2 className="text-sm font-semibold uppercase tracking-wide text-white" data-id="element-45" data-mp="mthlb43qmyyf">Nos formations</h2>
          <ul className="mt-4 space-y-2.5 text-sm" data-id="element-46" data-mp="twxuhinrnqdj">
            {formations.map(f => <li key={f.slug} data-id="element-47" data-mp="yupk260xv0ek">
                <Link to={`/formations/${f.slug}`} className="text-brand-200 transition-colors duration-150 ease-out hover:text-white" data-id="element-48" data-mp="yruyuca3pbk3">
                  {f.titre}
                </Link>
              </li>)}
          </ul>
        </nav>

        <nav aria-label="Informations" data-id="element-49" data-mp="1cnyu88wpnpy5">
          <h2 className="text-sm font-semibold uppercase tracking-wide text-white" data-id="element-50" data-mp="1hjnu6dcn78uz">Informations</h2>
          <ul className="mt-4 space-y-2.5 text-sm" data-id="element-51" data-mp="1mktougpv5675">
            <li data-id="element-52" data-mp="1mhxrathxgjj8">
              <Link to="/notre-approche" className="text-brand-200 hover:text-white" data-id="element-53" data-mp="1rildn1v7oc74">
                Notre approche
              </Link>
            </li>
            <li data-id="element-54" data-mp="3ocq1xuroio41">
              <Link to="/qualiopi" className="text-brand-200 hover:text-white" data-id="element-55" data-mp="3od80iy1tdef4">
                Qualité & Qualiopi
              </Link>
            </li>
            <li data-id="element-56" data-mp="2ag5firxejeh6">
              <Link to="/accessibilite" className="text-brand-200 hover:text-white" data-id="element-57" data-mp="2agomjdlikigf">
                Accessibilité & handicap
              </Link>
            </li>
            <li data-id="element-58" data-mp="21mab5m43ts2l">
              <Link to="/mentions-legales" className="text-brand-200 hover:text-white" data-id="element-59" data-mp="21nv4x9ilh6ze">
                Mentions légales
              </Link>
            </li>
          </ul>
        </nav>

        <div data-id="element-60" data-mp="2te9cko00ln2m">
          <h2 className="text-sm font-semibold uppercase tracking-wide text-white" data-id="element-61" data-mp="2tcy9yrib2ld3">Contact</h2>
          <ul className="mt-4 space-y-3 text-sm" data-id="element-62" data-mp="2pdfnvser048o">
            <li className="flex items-start gap-2 text-brand-200" data-id="element-63" data-mp="2pajrw9mgnpmv">
              <MapPinIcon size={15} className="mt-0.5 shrink-0" aria-hidden data-id="element-64" data-mp="2kbqa45055cgw" />
              <span data-id="element-65" data-mp="2fd5ao7spqwti">
                {site.nom}
                <br data-id="element-66" data-mp="2fgkqjcu7o9vz" />
                {site.adresse}
              </span>
            </li>
            <li data-id="element-67" data-mp="18w1n5dmw0dg3">
              <a href={`mailto:${site.email}`} className="inline-flex items-center gap-2 text-brand-200 hover:text-white" data-id="element-68" data-mp="13z1hv4xv3eq1">
                <MailIcon size={15} aria-hidden data-id="element-69" data-mp="2rug3lf5ufgo8" /> {site.email}
              </a>
            </li>
            <li data-id="element-70" data-mp="2wnr28t0i4r52">
              <a href={`tel:${site.telephoneLien}`} className="inline-flex items-center gap-2 text-brand-200 hover:text-white" data-id="element-71" data-mp="2wok9dv3dhinq">
                <PhoneIcon size={15} aria-hidden data-id="element-72" data-mp="2nunqcp5i8mcj" /> {site.telephone}
              </a>
            </li>
          </ul>
          <Link to="/contact" className="mt-5 inline-flex rounded-lg bg-accent-500 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-accent-600" data-id="element-73" data-mp="3bhm59idz7m8c">
            Demander un devis
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-74" data-mp="36mqdmjcnj0vr">
        <div className="mx-auto flex max-w-content flex-col gap-2 px-5 py-5 text-xs text-brand-200 sm:flex-row sm:items-center sm:justify-between lg:px-8" data-id="element-75" data-mp="1q6499hm7pbui">
          <p data-id="element-76" data-mp="1v3dxwv1s1jha">
            © {new Date().getFullYear()} {site.nom} — Organisme de formation certifié Qualiopi.
          </p>
          <p data-id="element-77" data-mp="1in4pvbyr3kb5">{site.site}</p>
        </div>
      </div>
    </footer>;
}